import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-header" }
const _hoisted_3 = { class: "popup-title" }
const _hoisted_4 = { class: "popup-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "pricing-table"
}
const _hoisted_7 = { class: "pricing-table-row" }
const _hoisted_8 = {
  key: 0,
  class: "pricing-table-row"
}
const _hoisted_9 = {
  key: 1,
  class: "pricing-table-row"
}
const _hoisted_10 = {
  key: 2,
  class: "pricing-table-row"
}
const _hoisted_11 = {
  key: 3,
  class: "pricing-table-row"
}
const _hoisted_12 = {
  key: 4,
  class: "pricing-table-row"
}
const _hoisted_13 = {
  key: 5,
  class: "pricing-table-row highlighted mt-1"
}
const _hoisted_14 = { class: "popup-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_gs_button = _resolveComponent("gs-button")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    width: "700",
    persistent: "",
    fullscreen: _ctx.isMobile,
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onUpdate
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t('shopify_header')), 1),
          _createElementVNode("button", {
            class: "popup-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
          }, [
            _createVNode(_component_v_icon, { size: 32 }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("mdi-close")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            innerHTML: _ctx.account.currency === 'dollar' ? _ctx.t('shopify_text_dollar') : _ctx.t('shopify_text')
          }, null, 8, _hoisted_5),
          (_ctx.account.currency !== 'dollar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.t('plan_price')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.isBusinessPlanAndYearly
                ? _ctx.t('plan_yearly', { price: _ctx.currencyDollar(_ctx.dollarPricing.planPrice) })
                : _ctx.t('plan_monthly', { price: _ctx.currencyDollar(_ctx.dollarPricing.planPrice) })), 1)
                ]),
                (_ctx.dollarPricing.standard)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t('standard_team_member')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.currencyDollar(_ctx.dollarPricing.standard)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dollarPricing.superior)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t('superior_team_member')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.currencyDollar(_ctx.dollarPricing.superior)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dollarPricing.premium)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t('premium_team_member')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.currencyDollar(_ctx.dollarPricing.premium)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dollarPricing.treePlanter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t('tree_planters')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.currencyDollar(_ctx.dollarPricing.treePlanter)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dollarPricing.plasticHero)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t('plastic_heros')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.currencyDollar(_ctx.dollarPricing.plasticHero)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.totalNewCost)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t('total')) + " " + _toDisplayString(_ctx.isActiveSubscriptionOnTrial ? _ctx.t('trial_period') : '') + ": ", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.currencyDollar(_ctx.totalNewCost)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_gs_button, {
            "full-width": "",
            size: "large",
            type: "primary",
            onClick: _ctx.handleClickContinue
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('continue')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_gs_button, {
            "full-width": "",
            type: "info",
            size: "large",
            onClick: _ctx.handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["fullscreen", "model-value", "onUpdate:modelValue"]))
}